import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[sanitizePaste]'
})
export class SanitizePasteDirective {

  constructor(private ngControl: NgControl) {}

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();

    const pastedText = event.clipboardData?.getData('text') || '';
    const sanitized = this.sanitizeText(pastedText);

    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const start = target.selectionStart || 0;
    const end = target.selectionEnd || 0;
    const currentValue = this.ngControl.value || '';

    const newValue = currentValue.slice(0, start) + sanitized + currentValue.slice(end);

    this.ngControl.control?.setValue(newValue);

    setTimeout(() => {
      target.selectionStart = target.selectionEnd = start + sanitized.length;
    });
  }

  private sanitizeText(text: string): string {
    return text
      .replace(/[\u2013\u2014]/g, '-')   // en dash/em dash → hyphen
      .replace(/[\u2018\u2019]/g, "'")    // smart single quotes → straight
      .replace(/[\u201C\u201D]/g, '"');   // smart double quotes → straight
  }
}
